import {NormalizerI} from "./normalizer.i";
import {isString} from "lodash";
const EMPTY = '';

export class DocumentNormalizer implements NormalizerI {

    normalize(value:string):string {
        if (!isString(value)) {
            return '';
        }
        return value.replace(/[ ]/g, EMPTY);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/normalizers/document.normalizer.ts